import React from "react"
import "./detailCard.scss"

const DetailCard = ({
  id,
  className,
  imageUrl,
  amazonUrl,
  kindleUrl,
  title,
  summary,
  createdAt,
}) => {
  return (
    <article key={id} className={`c-detailCard ${className}`}>
      <p className="c-detailCard-date">更新日：{createdAt}</p>
      <div className="c-detailCard-inner">
        <img
          src={imageUrl}
          alt="書籍イメージ画像"
          width="103"
          className="c-detailCard-image"
        />
        <div className="c-detailCard-description">
          <h2 className="c-detailCard-title">{title}</h2>
          <p className="c-detailCard-summary">{summary}</p>
          <div className="c-detailCard-buttonWrapper">
            <a
              href={amazonUrl}
              className="c-detailCard-button"
              target="_blank"
              rel="noreferrer"
            >
              Amazon
            </a>
            <a
              href={kindleUrl}
              className="c-detailCard-button"
              target="_blank"
              rel="noreferrer"
            >
              Kindle
            </a>
          </div>
        </div>
      </div>
    </article>
  )
}

export default DetailCard
